import React from "react";
import { Box, Button, Divider, Grid, LinearProgress } from "@material-ui/core";
import TextFieldHelper from "../../UI/FormHelper/TextFieldHelper";
import FieldDatePicker from "../../Form/FieldDatePicker";
import UserAutoComplete from "../../Form/UserAutoComplete";
import ChequeAddFromChequeable from "./ChequeAddFromChequeable";
import Checkbox from "@material-ui/core/Checkbox";
import Wrapper from "../../../hoc/Wrapper/Wrapper";
import ChequeAddFromRecieverable from "./ChequeAddFromRecieverable";

const ChequeAddFormFields = (props) => {
  const {
    values,
    touched,
    handleChange,
    isValid,
    setFieldTouched,
    setFieldValue,
    handleClose,
    handleSubmit,
    errors,
  } = props;

  return (
    <div>
      <form onSubmit={handleSubmit}>
        <Grid container>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper title={"بانک"} fieldName={"bank"} {...props} />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شعبه"}
                fieldName={"bank_branch"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ سر رسید"}
                fieldName={"due_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره چک"}
                fieldName={"cheque_id"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"شماره صیاد"}
                fieldName={"icis"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"مبلغ چک"}
                fieldName={"amount"}
                isNumber={true}
                {...props}
              />
            </Box>
          </Grid>

          <ChequeAddFromChequeable {...props} />

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"حساب"}
                fieldName={"account"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"صاحب چک"}
                fieldName={"first_party_id"}
                fieldNameShow={"first_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.first_party_fullname}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}></Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"در وجه"}
                fieldName={"second_party_id"}
                fieldNameShow={"second_party_fullname"}
                setFieldValue={setFieldValue}
                value={values.second_party_fullname}
              />
            </Box>
          </Grid>

          <Box style={{ width: "100%" }} mb={2} mt={2}>
            <Divider />
          </Box>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"دهنده چک"}
                fieldName={"giver_user_id"}
                fieldNameShow={"giver_user_fullname"}
                setFieldValue={setFieldValue}
                value={values.giver_user_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box m={1} key={"is_guarantee_cheque"}>
              <Box display={"flex"} justifyContent="flex-start">
                <Box>
                  <Checkbox
                    checked={values["is_guarantee_cheque"]}
                    color="primary"
                    onChange={(e) => {
                      setFieldValue(
                        "is_guarantee_cheque",
                        !values["is_guarantee_cheque"],
                      );
                    }}
                    inputProps={{ "aria-label": "secondary checkbox" }}
                  />
                </Box>
                <Box pt={1.5}>چک تضمینی</Box>
              </Box>
            </Box>
          </Grid>

          <ChequeAddFromRecieverable {...props} />

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"ضامن"}
                fieldName={"guarantor_id"}
                fieldNameShow={"guarantor_fullname"}
                setFieldValue={setFieldValue}
                value={values.guarantor_fullname}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <UserAutoComplete
                title={"معرف"}
                fieldName={"recommender_id"}
                fieldNameShow={"recommender_fullname"}
                setFieldValue={setFieldValue}
                value={values.recommender_fullname}
              />
            </Box>
          </Grid>

          <Box style={{ width: "100%" }} mb={2} mt={2}>
            <Divider />
          </Box>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ تحویل"}
                fieldName={"delivered_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ واگذاری"}
                fieldName={"transfered_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ برگشت خوردن"}
                fieldName={"bounced_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ پاس شدن"}
                fieldName={"cashed_date"}
                {...props}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box p={1}>
              <FieldDatePicker
                label={"تاریخ عودت"}
                fieldName={"returned_date"}
                {...props}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Box p={1}>
              <TextFieldHelper
                title={"وضعیت چک"}
                fieldName={"status"}
                {...props}
                select={true}
                options={[
                  { value: "bounced", label: "برگشتی" },
                  { value: "returned-settlement", label: "عودتی - تسویه" },
                  { value: "returned-unresolved", label: "عودتی - بلاتکلیف" },
                  { value: "cashed", label: "پاس شده" },
                  { value: "current", label: "جاری" },
                ]}
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Box p={1}>
              <TextFieldHelper
                title={"توضیحات"}
                fieldName={"description"}
                multiline={true}
                {...props}
              />
            </Box>
          </Grid>

          {props.isEdit ? (
            <Wrapper>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ویرایش"}
                    fieldName={"updated_at"}
                    {...props}
                    disabled={true}
                  />
                </Box>
              </Grid>
              <Grid item xs={12} md={6}>
                <Box p={1}>
                  <TextFieldHelper
                    title={"تاریخ ثبت"}
                    fieldName={"created_at"}
                    disabled={true}
                    {...props}
                  />
                </Box>
              </Grid>
            </Wrapper>
          ) : null}
        </Grid>

        <Box mt={2}>
          {props.loading ? (
            <Wrapper>
              <Button
                fullWidth={true}
                size={"large"}
                disabled={true}
                color={"default"}
              >
                در حال ارسال
              </Button>
              <LinearProgress />
            </Wrapper>
          ) : (
            <Button
              variant={"contained"}
              type="submit"
              size={"large"}
              fullWidth={true}
              color={"primary"}
            >
              {props.isEdit ? "ویرایش چک" : "افزودن چک"}
            </Button>
          )}
        </Box>
      </form>
    </div>
  );
};

export default ChequeAddFormFields;
